import { render, staticRenderFns } from "./Top5Walkers.vue?vue&type=template&id=a608ea08&scoped=true&lang=pug&"
import script from "./Top5Walkers.vue?vue&type=script&lang=js&"
export * from "./Top5Walkers.vue?vue&type=script&lang=js&"
import style0 from "./Top5Walkers.vue?vue&type=style&index=0&id=a608ea08&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a608ea08",
  null
  
)

export default component.exports